import { SVGProps } from 'react';

const SvgComponent = ({ selected, ...props }: SVGProps<SVGSVGElement> & { selected?: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={45} height={45} fill="none" {...props}>
        <rect width={45} height={45} fill={selected ? '#042F60' : '#fff'} rx={22.5} />
        <rect
            width={44.1}
            height={44.1}
            x={0.45}
            y={0.45}
            stroke={selected ? '#000' : '#707579'}
            strokeOpacity={selected ? 0.16 : 1}
            strokeWidth={0.9}
            rx={22.05}
        />
        <mask
            id="a"
            width={27}
            height={27}
            x={9}
            y={9}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'alpha',
            }}
        >
            <path fill="#D9D9D9" d="M9.9 9.9h25.2v25.2H9.9z" />
        </mask>
        <g mask="url(#a)">
            <path
                fill={selected ? '#fff' : '#000'}
                d="M16.2 30.9a2.022 2.022 0 0 1-1.482-.617A2.022 2.022 0 0 1 14.1 28.8c0-.578.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm6.3 0a2.022 2.022 0 0 1-1.483-.617 2.022 2.022 0 0 1-.616-1.483c0-.578.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm6.3 0a2.022 2.022 0 0 1-1.483-.617 2.022 2.022 0 0 1-.616-1.483c0-.578.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm-12.6-6.3a2.022 2.022 0 0 1-1.482-.617A2.022 2.022 0 0 1 14.1 22.5c0-.578.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm6.3 0a2.022 2.022 0 0 1-1.483-.617 2.022 2.022 0 0 1-.616-1.483c0-.578.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm6.3 0a2.022 2.022 0 0 1-1.483-.617 2.022 2.022 0 0 1-.616-1.483c0-.578.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm-12.6-6.3a2.022 2.022 0 0 1-1.482-.617A2.022 2.022 0 0 1 14.1 16.2c0-.577.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm6.3 0a2.022 2.022 0 0 1-1.483-.617 2.022 2.022 0 0 1-.616-1.483c0-.577.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Zm6.3 0a2.022 2.022 0 0 1-1.483-.617 2.022 2.022 0 0 1-.616-1.483c0-.577.205-1.072.616-1.483a2.022 2.022 0 0 1 1.484-.617c.577 0 1.072.206 1.483.617.411.411.617.905.617 1.483 0 .578-.206 1.072-.617 1.483a2.022 2.022 0 0 1-1.483.617Z"
            />
        </g>
    </svg>
);

export default SvgComponent;
